import { render, staticRenderFns } from "./CompareSliderModV2.vue?vue&type=template&id=2670cc68"
import script from "./CompareSliderModV2.vue?vue&type=script&lang=js"
export * from "./CompareSliderModV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports